import { render, staticRenderFns } from "./BoxOccupancyPowerHour.vue?vue&type=template&id=a0672ae4&"
import script from "./BoxOccupancyPowerHour.vue?vue&type=script&lang=js&"
export * from "./BoxOccupancyPowerHour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon,QTooltip,QSelect,QResizeObserver,QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QIcon,QTooltip,QSelect,QResizeObserver,QInnerLoading,QSpinnerTail})
